import React from 'react';
import styled from 'styled-components';
import { Typography, Box } from '@blueprint/ui';
import ExpandPanelWithProps from './ExpandPanelWithProps';
import { useTranslation } from 'react-i18next';

const StyledDiv = styled.div`
    padding-top: 100px;
    padding-right: 5vw;
    padding-left: 5vw;
`;

const Faq = () => {
    const { t } = useTranslation();
    console.log(window.location.href);

    const faqArrayJSX = [];
    for (let i = 0; i < 26; i++) {
        faqArrayJSX.push(<ExpandPanelWithProps title={t(`faq.content.${i}.question`)} content={t(`faq.content.${i}.answer`)} key={i} />);
    }

    return (
        <StyledDiv>
            <Box>
                <Box borderLeft='3px solid red' margin='0 0 2vw 0' paddingLeft='10px'>
                    <Typography variant='h1' className='page-title' tabIndex='-1'>
                        {t('faq.frequentlyAskedQuestions')}
                    </Typography>
                </Box>
            </Box>

            <Box marginTop={['10px', '10px', '10px', '24px']}>{faqArrayJSX}</Box>
        </StyledDiv>
    );
};

export default Faq;
